import { Button, Card, CardActions, CardContent, Grid2 as Grid, Typography} from "@mui/material";
import { Transaction } from "../types";

type Props = {
  transaction: Transaction;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTransaction: React.Dispatch<React.SetStateAction<Transaction | undefined>>;
}

function TransactionCard(props: Props) {

  const currencyPrinter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
  });

  return (<Card sx={{backgroundColor: "#e0f1ff"}}>
    <CardContent>
      <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
        {props.transaction.saleDate}
      </Typography>
      <Typography variant="h5" component="div">
        {props.transaction.Parcel.streetAddress}
      </Typography>
      <Typography variant="h5" component="div">
        {props.transaction.Parcel.city}
      </Typography>
      <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
        {props.transaction.Parcel.parcelType === 81 ? "Commercial" : "Industrial"}
      </Typography>
      <Typography variant="body2">
        <b>Price:</b>&nbsp;{currencyPrinter.format(props.transaction.price)}
      </Typography>
      <Typography variant="body2">
        <b>Parcel #:</b>&nbsp;{props.transaction.parcelNumber}
      </Typography>
      <Typography variant="body2">
        <b>Grantor:</b>&nbsp;{props.transaction.grantor}
      </Typography>
      <Typography variant="body2">
        <b>Grantee:</b>&nbsp;{props.transaction.grantee}
      </Typography>
      <Typography variant="body2">
        <b>Acres:</b>&nbsp;{props.transaction.Parcel.acres}
      </Typography>
      <Typography variant="body2">
        <b>Deed Type:</b>&nbsp;{props.transaction.deedType}
      </Typography>
    </CardContent>
    <CardActions>
      <Button 
        size="small" 
        variant="contained" 
        onClick={() => {
          props.setSelectedTransaction(props.transaction);
          props.setDialogOpen(true)
        }}
      >See Sale History</Button>
    </CardActions>
  </Card>);
}

export default TransactionCard;
